import { createFileRoute } from '@tanstack/react-router'
import { KanbanFullArea } from '~/components/routes/development/real-estate/kanban/kanban-full-area'
import { KANBAN_READ, realEstateTabGuard } from '~/components/routes/development/real-estate/tabs'

export const Route = createFileRoute('/_authenticated/development/real-estate/kanban')({
  staticData: { permission: KANBAN_READ },
  beforeLoad: realEstateTabGuard('kanban'),
  component: KanbanFullArea,
})
